





































































import { TenantUserModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { tenantUsersStore } from '@/libs/tenants/+state/store';

@Component({})
export default class UserSelect extends Vue {

    @VModel() innerValue!: string;
    @Prop({ default: "" }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!:  any[];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) createParty!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: true }) simple!: boolean;
    @Prop() placeholder!: string;
    @Prop() districtId!: string | null;
    @Prop() except!: Array<string>;
    @Prop() specificUsers!: Array<string>;

    @Ref() autocomplete!: Autocomplete;

    @Watch("innerValue")
    innerValueChanged(v: string, p: string) {
        console.log("UserSelect", v, p);
        if (v != p) {
            this.$emit("change", v);
        } 
    }

    get items(): TenantUserModel[] {
		let items = [...(tenantUsersStore.useGetter(CrudGetter.Data) as TenantUserModel[])].sort((a: TenantUserModel, b: TenantUserModel) => {
            if(a.user!.displayName! < b.user!.displayName!) { return -1; }
            if(a.user!.displayName! > b.user!.displayName!) { return 1; }
            return 0;
        });
        if (this.specificUsers?.count() > 0) {
            items = items.filter(x => this.specificUsers?.any(p => p == x.userId));
        }
        if (this.except?.count() > 0) {
            items = items.filter(x => !this.except?.any(p => p == x.userId) || x.userId == this.innerValue);
        }
        if (this.districtId) {
            items = items.filter((x: TenantUserModel) => {
                return x.mainDistrictId == this.districtId || x.userId == this.innerValue;
            });
        }
        return items;
    }

}
